/* @flow */

import { em } from 'polished';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  sponsorsTitle: {
    marginTop: em(25),
    color: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  sponsorsContainer: {
    display: 'flex',
    gap: em(20),
    alignItems: 'center',
    marginBottom: em(25),
  },
  sponsorLogo: {
    height: em(40),
    maxWidth: em(130),

    ['& img']: {
      maxWidth: '100%',
      objectFit: 'contain',
      height: '100%',
    },
  },
};
